<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g transform="translate(-21 -283)">
      <path class="a" d="M15,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H15" transform="translate(19 281)"/>
      <path class="a" d="M16,17l5-5L16,7" transform="translate(19 281)"/>
      <line class="a" x1="12" transform="translate(28 293)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'OfferedIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
